import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import '../../common/index.scss';
import Slider from 'react-slick';

// Import custom components
import Collection from "./collection"
import Section3 from "./section3"
import LogoBlock from "../common/logo-block"
import BlogSection from "../common/blogsection";
import HeaderThree from "../../common/headers/header-three"
import FooterTwo from "../../common/footers/footer-two"
import ThemeSettings from "../../common/theme-settings"
import FooterFour from "../../common/footers/footer-four";

//image
import Card from "../../../assets/images/card.jpg"
import {
    svgFreeShipping,
    svgservice,
    svgoffer,
    svgpayment
} from "../../../services/script"

class Pets extends Component {

    componentDidMount() {
        document.getElementById("color").setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/color20.css`);
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>ایزی کارت 724 | خانه</title>
                </Helmet>
                <HeaderThree logoName={'ezlogo1.png'} />
                <section className="p-0 small-slider">
                    <Slider className="slide-1 home-slider">
                        <div>
                            <div className="home home46">
                                <div className="container">
                                    <div className="row">
                                        <div className="col">
                                            <div className="slider-contain" style={{ float: 'right' }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <h4>ایزی کارت۷۲۴؛پلتفرم خرید
                                                        گیفت کارت و شماره مجازیّ</h4>
                                                    <h6 className='mt-2'>ایزی کارت۷۲۴ تداعی خلاقیت و نوآوری در دنیای پرداخت های انلاین است ، کیفیت محصولات ، پشتیبانی ویژه و منحصربه فرد از ویژگی های برجسته ایزی کارت۷۲۴ می باشد.</h6>
                                                    <a href="#" className="btn btn-solid">قوانین و مقررات</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Slider>
                </section>

                <section className="beauty-about">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-5 col-lg-6 col-md-12 mr-5 ml-0 text-center">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/pets/image/pix-1.png`} alt="" className="img-fluid blur-up lazyload" />
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-12">
                                <div className="about-section">
                                    <div>
                                        <h4>ایزی کارت۷۲۴ پیشگام در نقد کردن درآمد و پرداخت های بین الملل</h4>
                                        <div className="title1 title5">
                                            <hr role="tournament6" />
                                        </div>
                                        <div className="about-text">
                                            <h5>ما راه حل جدید و قطعی ارائه کرده ایم</h5>
                                            <p>خدمات ارائه شده در این ایزی کارت۷۲۴ حاصل سال ها تجربه موفق مدیران ما در ایجاد راهکارهای مناسب برای هر نوع پرداخت بین الملل می باشد، ما مفتخریم با استفاده از زیرساخت های نوین، خدماتی از جمله صدور انواع کارت های بین المللی، پرداخت های بین المللی، تعیین وقت سفارت، پرداخت های مسافرتی و دانشجویی، سیم کارت های
                                                بین المللی و هر نوع خدمات مبتنی بر پرداخت
                                                بین الملل را به شما هموطنان عزیز به بهترین نحو و در کوتاهترین زمان ارائه دهیم</p>
                                        </div>
                                        <div className="service small-section pb-0">
                                            <div className="row">
                                                <div className="col-sm-4 service-block1">
                                                    <div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: svgFreeShipping }} />
                                                    <h5>گیفت کارت</h5>
                                                </div>
                                                <div className="col-sm-4 service-block1">
                                                    <div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: svgservice }} />
                                                    <h5>پرداخت ارزی</h5>
                                                </div>
                                                <div className="col-sm-4 service-block1">
                                                    <div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: svgoffer }} />
                                                    <h5>کارت های اعتباری</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/*Logo Block section*/}
                {/* <LogoBlock /> */}
                {/*Logo Block section end*/}
                <section style={{ width: '60%', marginLeft: 'auto', marginRight: 'auto' }}>

                    <Section3 type={'pets'} title="دسترسی سریع به سرویس های محبوب" subtitle="Special Offer" />
                </section>


                {/*Parallax banner*/}
                <section className="p-0 pet-parallax">
                    <div className="full-banner parallax parallax-banner19  text-center p-center">
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    <div className="banner-contain" style={{ textAlign: 'center', marginLeft: '2rem' }}>
                                        <h4>
                                            حرفه ای ترین و ارزان ترین پنل شماره مجازی</h4>
                                        <h3>خرید شماره مجازی</h3>
                                        <p >ایزی کارت۷۲۴ سیستم اتوماتیک خرید شماره مجازی به صورت ارزان و مطمئن است، در ایزی کارت شما می توانید اقدام به خرید شماره مجازی برای تلگرام ، واتس اپ ، تیندر، اینستاگرام از کشور های امریکایی اروپایی و اسیایی نظیر امارات مالزی و... کنید. </p>
                                        <a href="#" className="mt-5 btn btn-solid black-btn" tabIndex="0">خرید شماره مجازی ارزان</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pet-decor">
                            <img src={Card} alt="" className="img-fluid blur-up lazyload" />
                        </div>
                    </div>
                </section>
        

                {/* Blog Section Section*/}
                <div className="container mt-5">
                    <div className="row">
                        <div className="col">
                            <div className="title1 title5">
                                <h4>آخرین مطالب مفید وبلاگ ما را بخوانید</h4>
                                <h2 className="title-inner1">آخرین های وبلاگ</h2>
                                <hr role="tournament6" />
                            </div>
                        </div>
                    </div>
                </div>
                <section className="section-b-space p-t-0 ratio2_3">
                    <BlogSection />
                </section>
                {/* Blog Section End*/}
                <ThemeSettings />
                <FooterFour logoName={'layout4/footerlogo.png'} />
            </div>
        )
    }
}


export default Pets;